import {
	FORMULA_OPERATIONS as FP,
	GeometryTypes,
	IAdjustHandlerDirection,
	PathOperationTypes,
	ShapeType,
} from "../widgets/interfaces/model/enumerations/index";
import { IPresetGeometry } from "../widgets/interfaces/model/geometry/PresetGeometry";

/**
 * rightArrow preset definition
 * ECMA-376, Third Edition, Part 1 - Fundamentals And Markup Language Reference
 * /OfficeOpenXML-DrawingMLGeometries/presetShapeDefinitions.xml
 */
export const rightArrow: IPresetGeometry = {
	ahLst: [
		{
			directionX: IAdjustHandlerDirection.REVERSE,
			gdRefX: "adj2", maxX: "maxAdj2", minX: 0, pos: { x: "x1", y: "t" },
		},
		{
			directionY: IAdjustHandlerDirection.REVERSE,
			gdRefY: "adj1", maxY: 100000, minY: 0, pos: { x: "l", y: "y1" },
			scaleY: 2,
		},
	],
	avList: [
		{ name: "adj1", fmla: { operation: FP.LiteralValue, operands: [50000] } },
		{ name: "adj2", fmla: { operation: FP.LiteralValue, operands: [50000] } },
	],
	gdLst: [
		// this is deviation from microsoft standards, introduced below terms for text padding inside shape
		// Here lp stands for left padding
		{ name: "lp", fmla: { operation: FP.AddSubtract, operands: ["l", 10, 0] } },
		/** Replaced ss(Shortest Side) to w(width) so that the maxAdj2 remain 100%.
         * So devaiting it from actual preset shape.
         */
		{ name: "maxAdj2", fmla: { operation: FP.MultiplyDivide, operands: [100000, "w", "w"] } },
		{ name: "a1", fmla: { operation: FP.PinTo, operands: [0, "adj1", 100000] } },
		{ name: "a2", fmla: { operation: FP.PinTo, operands: [0, "adj2", "maxAdj2"] } },
		/** FIX ME
         * In RightArrow instead of ss(Shortest Side) we are taking w(width) as if now.
         * If we take ss and width > height then the AdjustHandler of x-axis set to zero.
         * So for now we are devaiting it from actual preset shape.
         */
		{ name: "dx1", fmla: { operation: FP.MultiplyDivide, operands: ["w", "a2", 100000] } },
		{ name: "x1", fmla: { operation: FP.AddSubtract, operands: ["r", 0, "dx1"] } },
		{ name: "dy1", fmla: { operation: FP.MultiplyDivide, operands: ["h", "a1", 200000] } },
		{ name: "y1", fmla: { operation: FP.AddSubtract, operands: ["vc", 0, "dy1"] } },
		{ name: "y2", fmla: { operation: FP.AddSubtract, operands: ["vc", "dy1", 0] } },
		{ name: "dx2", fmla: { operation: FP.MultiplyDivide, operands: ["y1", "dx1", "hd2"] } },
		{ name: "x2", fmla: { operation: FP.AddSubtract, operands: ["x1", "dx2", 0] } },

	],
	pathLst: [{
		operations: [
			{ pt: { x: "l", y: "y1" }, type: PathOperationTypes.MOVE_TO },
			{ pt: { x: "x1", y: "y1" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "x1", y: "t" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "r", y: "vc" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "x1", y: "b" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "x1", y: "y2" }, type: PathOperationTypes.LINE_TO },
			{ pt: { x: "l", y: "y2" }, type: PathOperationTypes.LINE_TO },

			{ type: PathOperationTypes.CLOSE },
		],
	}],
	presetShape: ShapeType.rightArrow,
	rect: { l: "lp", t: "y1", r: "x2", b: "y2" },
	type: GeometryTypes.PRESET,
};

/**
 * Microsoft open xml preset definition (for Reference purpose only)
 * <rightArrow>
 *   <avLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <gd name="adj1" fmla="val 50000" />
 *     <gd name="adj2" fmla="val 50000" />
 *   </avLst>
 *   <gdLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <gd name="maxAdj2" fmla="* / 100000 w ss" />
 *     <gd name="a1" fmla="pin 0 adj1 100000" />
 *     <gd name="a2" fmla="pin 0 adj2 maxAdj2" />
 *     <gd name="dx1" fmla="* / ss a2 100000" />
 *     <gd name="x1" fmla="+- r 0 dx1" />
 *     <gd name="dy1" fmla="* / h a1 200000" />
 *     <gd name="y1" fmla="+- vc 0 dy1" />
 *     <gd name="y2" fmla="+- vc dy1 0" />
 *     <gd name="dx2" fmla="* / y1 dx1 hd2" />
 *     <gd name="x2" fmla="+- x1 dx2 0" />
 *   </gdLst>
 *   <ahLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <ahXY gdRefY="adj1" minY="0" maxY="100000">
 *       <pos x="l" y="y1" />
 *     </ahXY>
 *     <ahXY gdRefX="adj2" minX="0" maxX="maxAdj2">
 *       <pos x="x1" y="t" />
 *     </ahXY>
 *   </ahLst>
 *   <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <cxn ang="3cd4">
 *       <pos x="x1" y="t" />
 *     </cxn>
 *     <cxn ang="cd2">
 *       <pos x="l" y="vc" />
 *     </cxn>
 *     <cxn ang="cd4">
 *       <pos x="x1" y="b" />
 *     </cxn>
 *     <cxn ang="0">
 *       <pos x="r" y="vc" />
 *     </cxn>
 *   </cxnLst>
 *   <rect l="l" t="y1" r="x2" b="y2" xmlns="http://schemas.openxmlformats.org/drawingml/2006/main" />
 *   <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
 *     <path>
 *       <moveTo>
 *         <pt x="l" y="y1" />
 *       </moveTo>
 *       <lnTo>
 *         <pt x="x1" y="y1" />
 *       </lnTo>
 *       <lnTo>
 *         <pt x="x1" y="t" />
 *       </lnTo>
 *       <lnTo>
 *         <pt x="r" y="vc" />
 *       </lnTo>
 *       <lnTo>
 *         <pt x="x1" y="b" />
 *       </lnTo>
 *       <lnTo>
 *         <pt x="x1" y="y2" />
 *       </lnTo>
 *       <lnTo>
 *         <pt x="l" y="y2" />
 *       </lnTo>
 *       <close />
 *     </path>
 *   </pathLst>
 * </rightArrow>
 */
